import { z } from 'zod'

import { TypesAllergy } from '@/modules/medicalRecord/domain/models/AllergyPatientMedicalRecord'
import { BloodType } from '@/modules/medicalRecord/domain/models/BloodType'
import { MedicationAdministration } from '@/modules/medicalRecord/domain/models/FullPrescriptionPatient'
import { Gender } from '@/modules/medicalRecord/domain/models/PatientProfileMedicalRecord'
import { FoodRestrictionType } from '@/modules/operational/modules/restriction/domain/models/FoodRestrictionType'
import { PatientSelectiveness } from '@/modules/operational/modules/restriction/domain/models/PatientSelectiveness'
import { RemedyType } from '@/modules/remedies/domain/models/RemedyTypeEnum'
import { PersonaInfoSummary } from '@/modules/shared/schemas/PersonaInfoSummary'
import { ResponsibleType } from '@/ui/modules/admin/views/Responsibles/responsibleType'

export const ResponsibleMedicalRecord = z.object({
  id: z.string(),
  company: z.string(),
  patient: PersonaInfoSummary,
  responsibleName: z.string().nullable(),
  responsibleDocument: z.string().nullable(),
  responsibleBirthday: z.string().nullable(),
  responsibleGender: Gender.nullable(),
  responsibleType: ResponsibleType.nullable(),
  patientBirthDay: z.string().nullable(),
  height: z.number().nullable(),
  weight: z.number().nullable(),
  bloodType: BloodType.nullable(),
  patientGender: Gender.nullable(),
  foods: z.object({
    patientSelective: PatientSelectiveness.nullable(),
    foods: z.array(
      z.object({
        id: z.string(),
        food: z.string(),
        foodRestrictionType: FoodRestrictionType
      })
    )
  }),
  allergies: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
      typeAllergy: TypesAllergy
    })
  ),
  comorbidities: z.array(
    z.object({
      id: z.string(),
      name: z.string()
    })
  ),
  medications: z.array(
    z.object({
      id: z.string(),
      medication: z.string(),
      activeIngredient: z.string(),
      typeMedicine: RemedyType,
      medicationAdministration: MedicationAdministration
    })
  )
})
export type ResponsibleMedicalRecord = z.infer<typeof ResponsibleMedicalRecord>
